module.exports = __webpack_public_path__ + "assets/img/23_89.47ab8289.jpg";